"use strict";
/**
 * Created by rouven on 01.03.17.
 */
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var react_1 = __importDefault(require("react"));
var react_router_dom_1 = require("react-router-dom");
var react_symbol_1 = __importDefault(require("@wikom/react-symbol"));
var react_conditional_1 = __importDefault(require("@wikom/react-conditional"));
var GridLink = function (_a) {
    var symbol = _a.symbol, to = _a.to;
    return react_1["default"].createElement(react_router_dom_1.Link, { to: to },
        react_1["default"].createElement(react_symbol_1["default"], { symbol: symbol }));
};
var GridLinkWrapper = function (_a) {
    var _b = _a.condition, condition = _b === void 0 ? function () { return true; } : _b, props = __rest(_a, ["condition"]);
    console.warn('GridLink is deprecated, please use RenderColumn instead.');
    return (react_1["default"].createElement(react_conditional_1["default"], __assign({ condition: condition }, props, { passProps: true }),
        react_1["default"].createElement(GridLink, null)));
};
exports["default"] = GridLinkWrapper;
